import React, { useContext, useEffect, useRef } from "react";
import { Button, HStack, Text } from "@chakra-ui/react";
import { toast as toastify } from "react-toastify";
import { UpdateContext } from "../context/UpdateContext";

const UpdateNotification = () => {
  const { updateAvailable, skipUpdate, applyUpdate } =
    useContext(UpdateContext);
  const toastIdRef = useRef("app-update-toast");
  const didApplyUpdateRef = useRef(false);

  useEffect(() => {
    if (!updateAvailable) {
      return;
    }

    if (toastify.isActive(toastIdRef.current)) {
      return;
    }

    didApplyUpdateRef.current = false;

    toastify(
      ({ closeToast }) => (
        <HStack
          bg="blue.500"
          color="white"
          px={6}
          py={4}
          borderRadius="md"
          boxShadow="lg"
          justify="space-between"
          minW="300px"
          gap={6}
        >
          <Text fontWeight="medium">✨ New version available!</Text>
          <HStack gap={2}>
            <Button
              size="sm"
              bg="blue.600"
              _hover={{ bg: "blue.700" }}
              onClick={() => {
                skipUpdate();
                closeToast();
              }}
            >
              Later
            </Button>
            <Button
              size="sm"
              bg="white"
              color="blue.500"
              fontWeight="bold"
              _hover={{ bg: "gray.100" }}
              onClick={() => {
                didApplyUpdateRef.current = true;
                closeToast();
                applyUpdate();
              }}
            >
              Update Now
            </Button>
          </HStack>
        </HStack>
      ),
      {
        toastId: toastIdRef.current,
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        onClose: () => {
          if (!didApplyUpdateRef.current) {
            skipUpdate();
          }
        },
      },
    );
  }, [updateAvailable, skipUpdate, applyUpdate]);

  return null;
};

export default UpdateNotification;
